import {calculateSavings, extraPercentage} from "./logic";
import {lang, setLang, isTouch} from "./util";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import {getStrings} from "./strings";
import {initVideo, replayVideo} from "./video";

const playVideoBtn = document.querySelector("#playVideo");
const printBtn = document.querySelector("#print-button");
const replayBtn = document.querySelector("#replay-button");
const savingsGoalElem = document.querySelector("#savingsGoal");
const yourNameElem = document.querySelector("#yourName");
const howMuchElem = document.querySelector("#howMuch");

let strings; // TODO: Dynamic based on html lang
let rmFormatter;

let validator = {};

let pacStorage = {
    pacName: "",
    pacSavingsGoal: "",
    pacSavingsGoalIndefinite: "",
    pacBiWeeklyAmount: 0,
    pacBiWeeklySavings: 0,
    pacBiWeeklyExtraAmount: 0,
    pacBiWeeklyExtraSavings: 0,
    pacBiWeeklyExtraDifference: 0,
    pacMonthlyAmount: 0,
    pacMonthlySavings: 0
};

function init(){
    setLang(document.querySelector("html").getAttribute("lang"));
    strings = getStrings(lang); // TODO: Dynamic based on html lang
    rmFormatter = new Formatter(lang);
    if(isTouch){
        printBtn.classList.add("hidden");
    }
    validator = {
        validateName: () => {
            const nameValue = yourNameElem.value;
            let isValid = false;
            if(nameValue.length <= 0 || (nameValue.length === nameValue.split(' ').length - 1)){
                displayError("error-name");
            }
            else{
                hideError("error-name");
                isValid = true;
            }
            return isValid;
        },
        validateAmount: () => {
            const amountValue = howMuchElem.value;

            let isValid = false;
            let sanitizedValue = 0;
            try{
                sanitizedValue = rmFormatter.parseNumber(amountValue);
            }
            catch(error){
                displayError("error-amount");
                return isValid;
            }

            if(sanitizedValue === null || isNaN(sanitizedValue) || sanitizedValue < 25 || sanitizedValue > 50000){
                displayError("error-amount");
            }
            else{
                isValid = true;
                hideError("error-amount");
            }
            return isValid;
        }
    };
    playVideoBtn.addEventListener("click", (event) => {
        let isValid = true;
        Object.keys(validator).forEach((validatorFn) => {
            if(!validator[validatorFn]()){
                isValid = false;
            }
        });
        if(isValid){
            event.preventDefault();
            pacStorage.pacName = yourNameElem.value;
            pacStorage.pacNameUppercase = yourNameElem.value.toUpperCase();
            pacStorage.pacSavingsGoalKey = savingsGoalElem.value;
            pacStorage.pacSavingsGoal = strings["savingsGoal"][savingsGoalElem.value];
            pacStorage.pacSavingsGoalIndefinite = strings["savingsGoalIndefinite"][savingsGoalElem.value];            
            pacStorage.pacMonthlyAmount = rmFormatter.parseNumber(howMuchElem.value) || 0; // TODO: Add validation
            pacStorage.pacMonthlySavings = calculateSavings(pacStorage.pacMonthlyAmount, "monthly");
            pacStorage.pacBiWeeklyAmount = pacStorage.pacMonthlyAmount / 2;
            pacStorage.pacBiWeeklySavings = calculateSavings(pacStorage.pacBiWeeklyAmount, "biweekly");
            pacStorage.pacBiWeeklyDifference = pacStorage.pacBiWeeklySavings - pacStorage.pacMonthlySavings;
            pacStorage.pacBiWeeklyExtraAmount = pacStorage.pacBiWeeklyAmount * extraPercentage;
            pacStorage.pacBiWeeklyExtraSavings = calculateSavings(pacStorage.pacBiWeeklyExtraAmount + pacStorage.pacBiWeeklyAmount, "biweekly");
            pacStorage.pacBiWeeklyExtraDifference = pacStorage.pacBiWeeklyExtraSavings - pacStorage.pacMonthlySavings;
            pacStorage.pacDate = rmFormatter.formatDate(new Date(), "yyyy-mm-dd");
            pacStorage.formattedOutput = {
                pacMonthlyAmount: rmFormatter.formatCurrency(pacStorage.pacMonthlyAmount, 0),
                pacMonthlySavings: rmFormatter.formatCurrency(pacStorage.pacMonthlySavings, 0),
                // pacBiWeeklyAmount: (Number.isInteger(pacStorage.pacBiWeeklyAmount))? rmFormatter.formatCurrency(pacStorage.pacBiWeeklyAmount, 0) : rmFormatter.formatCurrency(pacStorage.pacBiWeeklyAmount, 2),
                pacBiWeeklyAmount: rmFormatter.formatCurrency(pacStorage.pacBiWeeklyAmount, 0),
                pacBiWeeklySavings: rmFormatter.formatCurrency(pacStorage.pacBiWeeklySavings, 0),
                pacBiWeeklyDifference: rmFormatter.formatCurrency(pacStorage.pacBiWeeklyDifference, 0),
                pacBiWeeklyExtraAmount: rmFormatter.formatCurrency(pacStorage.pacBiWeeklyExtraAmount, 0),
                pacBiWeeklyExtraSavings: rmFormatter.formatCurrency(pacStorage.pacBiWeeklyExtraSavings, 0),
                pacBiWeeklyExtraDifference: rmFormatter.formatCurrency(pacStorage.pacBiWeeklyExtraDifference, 0)
            };
            setSessionStorage(pacStorage);
            // Play video
            $(".page-container .header, .page-container .inputs-container").hide();
            $(".page-container #video-container").show();
            document.querySelector(".page-container #video-container").scrollIntoView();
            initVideo(pacStorage, true);
        }
    });

    printBtn.addEventListener("click", (event) => {
        event.preventDefault();
        window.open("print.html");
    });
    // Monthly saving input formatting
    howMuchElem.addEventListener("change", (event) => {
        let _val = (rmFormatter.parseNumber(event.target.value)) ? rmFormatter.parseNumber(event.target.value) : 0;
        event.target.value = rmFormatter.formatNumber(_val, 0);
    });
    // Replay button
    replayBtn.addEventListener("click", (event) => {
        event.preventDefault();
        $(".page-container .end-screen").hide();
        $(".page-container #video-container").show();
        replayVideo(pacStorage);
    });
}

function setSessionStorage(storage){
    let printStorage = {
        "pacName": storage.pacName,
        "pacSavingsGoal": storage.pacSavingsGoal,
        "pacSavingsGoalIndefinite": storage.pacSavingsGoalIndefinite,
        "pacSavingsGoalKey": storage.pacSavingsGoalKey,
        "pacMonthlyAmount": rmFormatter.formatCurrency(storage.pacMonthlyAmount, 0),
        "pacMonthlySavings": rmFormatter.formatCurrency(storage.pacMonthlySavings, 0),
        // "pacBiWeeklyAmount": (Number.isInteger(storage.pacBiWeeklyAmount))? rmFormatter.formatCurrency(storage.pacBiWeeklyAmount, 0) : rmFormatter.formatCurrency(storage.pacBiWeeklyAmount, 2),
        "pacBiWeeklyAmount": rmFormatter.formatCurrency(storage.pacBiWeeklyAmount, 0),
        "pacBiWeeklySavings": rmFormatter.formatCurrency(storage.pacBiWeeklySavings, 0),
        "pacBiWeeklyExtraAmount": rmFormatter.formatCurrency(storage.pacBiWeeklyExtraAmount, 0),
        "pacBiWeeklyExtraSavings": rmFormatter.formatCurrency(storage.pacBiWeeklyExtraSavings, 0),
        "pacBiWeeklyDifference": rmFormatter.formatCurrency(storage.pacBiWeeklyExtraDifference, 0)
    };
    window.sessionStorage.setItem("pacPrint", JSON.stringify(printStorage));

}

function displayError(id){
    const errorElem = document.getElementById(id);
    errorElem.setAttribute("aria-hidden", "false");
    errorElem.setAttribute("role", "alert");
    errorElem.style.display = "block";
    errorElem.focus();
}

function hideError(id){
    const errorElem = document.getElementById(id);
    errorElem.setAttribute("aria-hidden", "true");
    errorElem.removeAttribute("role");
    errorElem.style.display = "none";
}

export {
    init as initPAC
};